import {call, put, takeEvery} from 'redux-saga/effects'
import Api from "../services/Api";

function* fetchPlanningManagement() {
  try {
    const planningManagement = yield call(function() {
      return Api.get('/dealer/planning-management');
    });
    yield put({type: 'FETCH_PLANNING_MANAGEMENT.SUCCESS', planningManagement})
  } catch (error) {
    yield put({type: 'FETCH_PLANNING_MANAGEMENT.FAILURE', error})
  }
}

export function* watchFetchPlanningManagement() {
  yield takeEvery('FETCH_PLANNING_MANAGEMENT.REQUEST', fetchPlanningManagement);
}

function* savePlanningManagement(action) {
  try {
    const planningManagement = yield call(function() {
      return Api.post('/dealer/planning-management', action.body)
    });

    yield put({type: 'SHOW_NOTIFICATION', notification:{message:'save.success'}});
    yield put({type: 'FETCH.DEALER_CONFIGURATION_CHECK.REQUEST'});
    yield put({type: 'SAVE_PLANNING_MANAGEMENT.SUCCESS', planningManagement});
  } catch (error) {
    yield put({type: 'SAVE_PLANNING_MANAGEMENT.FAILURE', error});
  }
}

export function* watchSavePlanningManagement() {
  yield takeEvery('SAVE_PLANNING_MANAGEMENT.REQUEST', savePlanningManagement)
}
